// eslint-disable-next-line @typescript-eslint/no-var-requires
import {PLATFORM_SUPPORT_LANGUAGES} from '@bfe/by-shared-settings';

export const locales = PLATFORM_SUPPORT_LANGUAGES.map((locale) => locale.value);

export const isSupportLocale = (locale) => locale && locales.includes(locale);
